import { render } from "./Header.vue?vue&type=template&id=8e326a52"
import script from "./Header.ts?vue&type=script&lang=ts"
export * from "./Header.ts?vue&type=script&lang=ts"
script.render = render

export default script